import { Directive, ElementRef, inject, Input, OnInit } from '@angular/core';

/**
 * Truncate text directive
 * Usage: <p appTruncate [lines]="3">Long text here...</p>
 */
@Directive({
  selector: '[ktAppTruncate]',
  standalone: true
})
export class TruncateDirective implements OnInit {
  @Input() lines = 1;

  el = inject(ElementRef);

  ngOnInit(): void {
    this.el.nativeElement.style.display = '-webkit-box';
    this.el.nativeElement.style.webkitLineClamp = this.lines;
    this.el.nativeElement.style.webkitBoxOrient = 'vertical';
    this.el.nativeElement.style.overflow = 'hidden';
  }
}
